import script from "./InternalWondeImportView.vue?vue&type=script&setup=true&lang=ts"
export * from "./InternalWondeImportView.vue?vue&type=script&setup=true&lang=ts"

import "./InternalWondeImportView.vue?vue&type=style&index=0&id=6401725c&scoped=true&lang=css"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6401725c"]])

export default __exports__